import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { useUpdateEffect } from '@core/js/hooks/useUpdateEffect';

const OPENED_MENU_Z_INDEX = '99';
const CLOSED_MENU_Z_INDEX = '97';

const changeZIndexLeftMenu = (isOpened: boolean): void => {
    const rootVariables: HTMLElement | null = document.querySelector(':root');

    if (!rootVariables) {
        return;
    }

    rootVariables.style.setProperty('--header-z-index', isOpened ? OPENED_MENU_Z_INDEX : CLOSED_MENU_Z_INDEX);
};

type THandleToggleLeftMenuConfig = {
    handleToggleLeftMenu: (event: React.MouseEvent<HTMLElement | SVGElement>) => void;
    isOpenLeftMenu?: boolean;
}

export const useHandleToggleLeftMenu = () => {
    const [isOpenLeftMenu, setIsOpenedLeftMenu] = useState(false);

    useUpdateEffect(() => {
        if (!isOpenLeftMenu) {
            return;
        }

        setIsOpenedLeftMenu(false);
        changeZIndexLeftMenu(false);
        dispatcher.dispatch('menu:action:close');
    }, []);

    useEffect(() => {
        const handleCloseMenu = (): void => {
            setIsOpenedLeftMenu(false);
            changeZIndexLeftMenu(false);
        };

        dispatcher.listen('menu:action:leftMenuClosed', handleCloseMenu);

        return () => {
            dispatcher.removeListener('menu:action:leftMenuClosed', handleCloseMenu);
        };
    }, []);

    const handleToggleLeftMenu = useCallback(() => {
        setIsOpenedLeftMenu(isOpened => {
            changeZIndexLeftMenu(true);
            dispatcher.dispatch(`menu:action:${isOpened ? 'close' : 'open'}`);

            return !isOpened;
        });
    }, []);

    return useMemo((): THandleToggleLeftMenuConfig => ({
        handleToggleLeftMenu,
        isOpenLeftMenu
    }), [handleToggleLeftMenu, isOpenLeftMenu]);
};

export const triggerCloseLeftMenu = (): void => {
    dispatcher.dispatch('menu:action:close');
};
